import { useOutletContext } from 'react-router-dom'
import { EspelhoPeriodo } from 'service/api'

export function useEspelhoPeriodoOutletContext() {
    return useOutletContext<{
        data: EspelhoPeriodo[]
    }>()
}
